export const COLORS = {
  rainbow: [
    'var(--rainbow-black, hsl(0deg 0% 18%))',
    'hsl(30deg 60% 30%)',
    'hsl(0deg 90% 55%)',
    'hsl(30deg 95% 65%)',
    'hsl(55deg 90% 65%)',
    'hsl(100deg 65% 45%)',
    'hsl(220deg 80% 55%)',
    'hsl(265deg 80% 50%)',
  ],
  trans: [
    'hsl(200deg 85% 70%)',
    'hsl(350deg 85% 85%)',
    'hsl(0deg 0% 100%)',
    'hsl(350deg 85% 85%)',
    'hsl(200deg 85% 70%)',
  ],
  pan: [
    'hsl(331deg 100% 55%)',
    'hsl(50deg 100% 50%)',
    'hsl(200deg 100% 55%)',
  ],
  'rainbow-original': [
    'hsl(0deg 90% 55%)',
    'hsl(30deg 95% 65%)',
    'hsl(55deg 90% 65%)',
    'hsl(100deg 65% 45%)',
    'hsl(220deg 80% 55%)',
    'hsl(265deg 80% 50%)',
  ],
  nonbinary: ['#ffd800', '#ffffff', '#9c59d1', '#333333'],
  queer: [
    'var(--rainbow-black, hsl(0deg 0% 18%))',
    '#98d8e8',
    '#00a2e7',
    '#b8e527',
    '#FFFFFF',
    '#ffcb20',
    '#ff6669',
    '#ffadc9',
    'var(--rainbow-black, hsl(0deg 0% 18%))',
  ],
};
